import CryptoJS from "crypto-js"; // Importera CryptoJS
import Cookies from "js-cookie";
import "./assets/styles/App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';

import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import SignOut from "./pages/auth/SignOut";
import UserProfile from "./pages/auth/UserProfile";
import QuizPage from "./pages/QuizPage";
import ActualQuiz from "./pages/ActualQuiz";

import AboutPage from "./pages/AboutPage";
import AllemansrattenPage from "./pages/AllemansrattenPage";

import MapPage from "./pages/MapPage";
import AdminHome from "./pages/admin/AdminHome";
import AdminSpeciesPage from "./pages/admin/AdminSpeciesPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AdminMap from "./pages/admin/AdminMap";
import AccessDenied from "./components/error/AccessDenied";
import AdminAreasPage from "./pages/admin/AdminAreasPage";
import AdminUserSettingsPage from "./pages/admin/AdminUserSettingsPage";

import AdminQuizPage from "./pages/admin/AdminQuizPage";
import AdminQuizSettingsPage from "./pages/admin/AdminQuizSettingsPage";

import StartPage from "./pages/StartPage";
import SpeciesInfoPage from "./pages/SpeciesInfoPage";
import AdminEditAreaPage from "./pages/admin/AdminEditAreaPage";
import OrderBadgePage from "./pages/OrderBadgePage";
import UserProfilePage from "./pages/UserProfilePage";


import ScrollToTop from "./components/ScrollToTop";

const secretKey = "din-hemliga-nyckel"; // Samma nyckel som i SignIn.js

// Funktion för att dekryptera cookies
const decryptCookie = (encryptedValue) => {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
};

// Helper function to get access role from cookie
const getAccessRole = () => {
    const encryptedAccess = Cookies.get("access");
    return encryptedAccess ? decryptCookie(encryptedAccess) : null;
};

// Inner component that re-reads the cookie on route changes
function AppContent() {
    const location = useLocation();
    const [accessRole, setAccessRole] = useState(getAccessRole());

    // Re-check the cookie whenever the route changes
    useEffect(() => {
        setAccessRole(getAccessRole());
    }, [location]);

    return (
        <>
            <ScrollToTop />
            <div className="App">
                <Switch>
                    <Route exact path="/">
                        <StartPage />
                        
                    </Route>


                    <Route exact path="/SignIn">
                        <SignIn />
                    </Route>

                    <Route exact path="/SignUp">
                        <SignUp />
                    </Route>

                    <Route exact path="/SignOut">
                        <SignOut />
                    </Route>

                    <Route exact path="/ResetPassword">
                        <ResetPassword />
                    </Route>

                    <Route exact path="/ForgotPassword">
                        <ForgotPassword />
                    </Route>

                    <Route exact path="/UserProfile">
                        {accessRole === "USER" || accessRole === "ADMIN" ? (
                            <UserProfile />
                        ) : (
                            <AccessDenied />
                        )}
                    </Route>

                    <Route exact path="/my-profile">
                        <UserProfilePage />
                    </Route>

                    <Route exact path="/quiz">
                        <QuizPage />
                    
                    </Route>

                    <Route exact path="/omraden">
                        <MapPage />
                    
                    </Route>
                    
                    <Route exact path="/arter">
                        <SpeciesInfoPage />
                    </Route>

                    <Route exact path="/om">
                        <AboutPage />
                    </Route>

                    <Route exact path="/allemansratten">
                        <AllemansrattenPage />
                    </Route>

                    
                    <Route exact path="/admin">
                        {accessRole === "ADMIN" || accessRole === "LOCALADMIN" ? <AdminHome /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>

                    <Route exact path="/admin-omraden">
                        {accessRole === "ADMIN" || accessRole === "LOCALADMIN" ? <AdminAreasPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>
                    
                    <Route exact path="/admin-arter">
                        {accessRole === "ADMIN" ? <AdminSpeciesPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>

                    <Route exact path="/admin-quiz">
                        {accessRole === "ADMIN" ? <AdminQuizPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>
                    <Route exact path="/admin-quiz-settings">
                        {accessRole === "ADMIN" ? <AdminQuizSettingsPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>
                    <Route exact path="/admin-user-settings">
                        {accessRole === "ADMIN" ? <AdminUserSettingsPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>




                    <Route exact path="/take-quiz">
                        <ActualQuiz />
                    </Route>

                    
                    <Route exact path="/admineditmap">
                        {accessRole === "ADMIN" ? <AdminEditAreaPage /> : <AccessDenied info={"Ingen admin-åtkomst"} />}
                    </Route>


                    <Route exact path= "/orderBadge">
                        <OrderBadgePage />
                    </Route>

                </Switch>
            </div>
        </>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;


{/* <- Använd detta för att kommentera ut -> */}